import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b7c6e7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold" }, "Dato for hendelse", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "field-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.mode === 'view')
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.date_formatted), 1))
      : (_ctx.mode === 'edit')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "w-full",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event))
            }, null, 512), [
              [_vModelText, _ctx.value]
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ]))
}